const readFlag = (key: string): string | undefined => {
  const runtime = (window as any).RUNTIME_ENV;
  if (runtime && typeof runtime[key] === 'string') {
    return runtime[key];
  }
  if (typeof process !== 'undefined' && process.env && typeof process.env[key] === 'string') {
    return process.env[key];
  }
  return undefined;
};

const truthy = (value: string | undefined): boolean =>
  value != null && ['1', 'true', 'yes', 'on'].includes(value.toLowerCase());

export const isMoroccoMapEnabled = (): boolean =>
  truthy(readFlag('ENABLE_MOROCCO_MAP'));
